import consumerApi from "@/api/services/consumer-api-fetch";
import { City, GetCitiesNearMeParams } from "@/custom-types/CitiesNearMe";
import logError from "@/utils/logError";

export const getFinderCitiesNearMe = async ({
  location,
  countryCode: country,
  medical,
  recreational,
  retailType: retail_type = "dispensary",
  delivery_enabled,
}: GetCitiesNearMeParams): Promise<City[]> => {
  const lat = location?.coordinates?.lat;
  const lon = location?.coordinates?.lon;

  try {
    const params = {
      lat: lat.toFixed(3),
      lon: lon.toFixed(3),
      retail_type,
      ...(location.city && { current_city: encodeURI(location.city) }),
      ...(medical && { medical: true }),
      ...(recreational && { recreational: true }),
      delivery_enabled,
    };

    const { data } = await consumerApi.GET("/api/cities_near_me/v1/finder", {
      headers: { "X-Country-Code": country },
      params: {
        query: params,
      },
    });
    return data?.data || [];
  } catch (error) {
    logError(error.message, {
      functionName: "getFinderCitiesNearMe",
      service: "consumer",
      statusCode: error.statusCode,
    });
    return [];
  }
};

export default getFinderCitiesNearMe;
